import { AppReducer } from "./app";
import { CourseReducer } from "./course";
import { CourseDataReducers } from "./courseData";
import { UserReducer } from "./user";
import { SettingReducer } from "./settings";
import { ResourceReducer } from "./resource";
import { TestReducer } from "./tests";
import { DropboxReducer } from "./dropbox";
import { CalendarEventReducer } from "./calendar";
import { DiscussionReducer } from "./discussion";
import { DropdownDataReducer } from "./dropdown";
import { MailboxReducer } from "./mailbox";
import { GradebookReducer } from "./gradebook";
import { CertificateReducer } from "./certificates";
import { DashboardReducer } from "./dashboard";
import { AdminAnnouncementReducer } from "./adminAnnouncement";
import { MyGradesReducer } from "./grades";
import { StartEndDateReducer } from "./startEndDates";
import { gradebookGradeReducer } from "./gradebookGrade";
import { ModuleSettingsReducer } from "./moduleSetting";
import { NotificationReducer } from "./notifications";
import { ReportsReducer } from "./reports";
import { CourseCloneReducer } from "./courseClone";
import { TeachingAssistantReducer } from "./teachingAssistant";
import gradeBookAttendanceReducer from "./gradeBookAttendance";
import { WooCommerceReducer } from "./wooCommerce";
import { surveyPreview, surveyPreviewReducer } from "./surveyPreview";

const appReducer = {
  user: UserReducer,
  app: AppReducer,
  courseData: CourseDataReducers,
  course: CourseReducer,
  resource: ResourceReducer,
  setting: SettingReducer,
  tests: TestReducer,
  dropbox: DropboxReducer,
  calendar: CalendarEventReducer,
  discussion: DiscussionReducer,
  dropdown: DropdownDataReducer,
  mailBox: MailboxReducer,
  gradebook: GradebookReducer,
  certificate: CertificateReducer,
  dashboard: DashboardReducer,
  adminAlert: AdminAnnouncementReducer,
  grades: MyGradesReducer,
  courseDates: StartEndDateReducer,
  userGrade: gradebookGradeReducer,
  moduleSetting: ModuleSettingsReducer,
  notification: NotificationReducer,
  reports: ReportsReducer,
  courseClone: CourseCloneReducer,
  teachingAssistant: TeachingAssistantReducer,
  gradeBookAttendance: gradeBookAttendanceReducer,
  wooComm: WooCommerceReducer,
  surveyPreview: surveyPreviewReducer,
};

export default appReducer;
